import React from 'react';
import { fixDecimal } from 'App/app/cart-logic';
import { currency } from 'App/config';
import { DeliveryTypes } from 'App/order-fields';
import { isTakeoutPossible } from 'Utils/restaurant';
var OrderFormDeliveryErrors = function (props) {
    var cartTotal = props.cartTotal, _a = props.errorClassName, errorClassName = _a === void 0 ? 'text-danger my-2' : _a, children = props.children, deliveryMode = props.deliveryMode, isCartEnoughForDelivery = props.isCartEnoughForDelivery, minCartAmount = props.minCartAmount, restaurantDetails = props.restaurantDetails;
    if (!isCartEnoughForDelivery && deliveryMode !== DeliveryTypes.takeout) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: errorClassName },
                "Brak mo\u017Cliwo\u015Bci zam\u00F3wienia - dostawa mo\u017Cliwa po przekroczeniu kwoty",
                ' ',
                minCartAmount,
                " ",
                currency,
                " (brakuje",
                ' ',
                fixDecimal(minCartAmount - cartTotal),
                " ",
                currency,
                ")"),
            children && children(true)));
    }
    if (deliveryMode === DeliveryTypes.takeout &&
        !isTakeoutPossible(restaurantDetails)) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: errorClassName }, "Brak mo\u017Cliwo\u015Bci zam\u00F3wienia z odbiorem osobistym"),
            children && children(true)));
    }
    return React.createElement(React.Fragment, null, children && children(false));
};
OrderFormDeliveryErrors.displayName = 'OrderFormDeliveryErrors';
export default OrderFormDeliveryErrors;
